module.exports = __webpack_public_path__ + "img/red-hat.9aff1918.webp";